var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8194 47.1345C12.0194 45.928 6.994 45.3194 2.119 44.7619C1.069 44.645 0.094151 45.2972 0.019151 46.2162C-0.130849 47.1358 0.61959 47.9769 1.59459 48.0938C6.31959 48.6305 11.1941 49.2048 15.7691 50.3663C16.7442 50.6182 17.7946 50.0996 18.0946 49.2075C18.3946 48.3161 17.7944 47.3871 16.8194 47.1345Z",
    fill: "#E1E9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3688 30.0296C23.6438 22.9688 14.9438 16.8168 7.36882 9.56655C6.69382 8.88942 5.49382 8.85315 4.74382 9.48527C3.99382 10.1181 3.91912 11.1821 4.66912 11.8593C12.2441 19.1303 20.9441 25.3024 28.6691 32.3841C29.4191 33.0451 30.6188 33.0545 31.3688 32.4042C32.0438 31.7546 32.1188 30.6906 31.3688 30.0296Z",
    fill: "#E1E9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8456 2.87117C46.0706 6.91245 46.2951 10.9537 46.5201 14.9957C46.5201 15.9214 47.4206 16.6361 48.4706 16.5911C49.5206 16.5454 50.2701 15.7575 50.2701 14.8311C50.0451 10.7831 49.8206 6.73578 49.5956 2.68845C49.5206 1.76277 48.6204 1.05273 47.5704 1.10311C46.5954 1.15349 45.7706 1.94617 45.8456 2.87117Z",
    fill: "#E1E9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccents);
export default __webpack_public_path__ + "static/media/accents.b1363d7a31a008608a1c922b560280f8.svg";
export { ForwardRef as ReactComponent };